var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProducts14X48({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 9.69116,
    width: 20.7353,
    height: 20.7353,
    rx: 2.25,
    fill: "white",
    stroke: "#5B5E5D",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.32884 3.6818C1.1531 3.85754 1.1531 4.14246 1.32884 4.3182L4.19262 7.18198C4.36835 7.35772 4.65328 7.35772 4.82901 7.18198C5.00475 7.00624 5.00475 6.72132 4.82901 6.54558L2.28343 4L4.82901 1.45442C5.00475 1.27868 5.00475 0.993756 4.82901 0.81802C4.65328 0.642284 4.36835 0.642284 4.19262 0.81802L1.32884 3.6818ZM21.7299 4.3182C21.9057 4.14246 21.9057 3.85754 21.7299 3.6818L18.8662 0.81802C18.6904 0.642284 18.4055 0.642284 18.2298 0.81802C18.054 0.993756 18.054 1.27868 18.2298 1.45442L20.7753 4L18.2298 6.54558C18.054 6.72132 18.054 7.00624 18.2298 7.18198C18.4055 7.35772 18.6904 7.35772 18.8662 7.18198L21.7299 4.3182ZM1.64703 4.45H21.4117V3.55H1.64703V4.45Z",
    fill: "#5B5E5D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3182 10.2701C28.1425 10.0943 27.8575 10.0943 27.6818 10.2701L24.818 13.1338C24.6423 13.3096 24.6423 13.5945 24.818 13.7702C24.9938 13.946 25.2787 13.946 25.4544 13.7702L28 11.2247L30.5456 13.7702C30.7213 13.946 31.0062 13.946 31.182 13.7702C31.3577 13.5945 31.3577 13.3096 31.182 13.1338L28.3182 10.2701ZM27.6818 30.6712C27.8575 30.8469 28.1425 30.8469 28.3182 30.6712L31.182 27.8074C31.3577 27.6316 31.3577 27.3467 31.182 27.171C31.0062 26.9952 30.7213 26.9952 30.5456 27.171L28 29.7166L25.4544 27.171C25.2787 26.9952 24.9938 26.9952 24.818 27.171C24.6423 27.3467 24.6423 27.6316 24.818 27.8074L27.6818 30.6712ZM27.55 10.5883L27.55 30.353L28.45 30.353L28.45 10.5883L27.55 10.5883Z",
    fill: "#5B5E5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts14X48);
export default __webpack_public_path__ + "static/media/products-14X48.00737954d02a5878585589bc640f5bc5.svg";
export { ForwardRef as ReactComponent };